module.exports = __webpack_public_path__ + "img/Praktisch.b1d8d279.webp";